const KeenSlider = window.KeenSlider

const { setInitialised } = window.BAO.Carousel.plugins

class CategoryLinking extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 'auto',
          spacing: 16,
        },
        breakpoints: {
          '(min-width: 768px)': {
            disabled: true,
          },
        },
      },
      [setInitialised()],
    )
  }
}

if (!customElements.get('category-linking')) {
  customElements.define('category-linking', CategoryLinking)
}
